import { render, staticRenderFns } from "./jguide.vue?vue&type=template&id=9f81ff1a&scoped=true"
import script from "./jguide.vue?vue&type=script&lang=js"
export * from "./jguide.vue?vue&type=script&lang=js"
import style0 from "./jguide.vue?vue&type=style&index=0&id=9f81ff1a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f81ff1a",
  null
  
)

export default component.exports